/* IcySkyFall Spin to Win — TactileWheel edition.
   SVG wheel matches MagicPath gladly-storm-1608 exactly: gold bevel rim,
   alternating wedge fills, gloss ellipse, olive hub, drop shadow.
   Prize segments from data-isf-spin-prizes (JSON from section settings).
   No hardcoded tier count or odds — all derived from prizes array.
   No exit-intent / time / scroll triggers. */
(function () {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pickWeightedIndex(prizes) {
    var total = prizes.reduce(function (s, p) { return s + (p.weight || 1); }, 0);
    var roll = Math.random() * total;
    for (var i = 0; i < prizes.length; i++) {
      roll -= (prizes[i].weight || 1);
      if (roll <= 0) return i;
    }
    return 0;
  }

  function svgEl(tag, attrs) {
    var el = document.createElementNS(SVG_NS, tag);
    Object.keys(attrs).forEach(function (k) { el.setAttribute(k, attrs[k]); });
    return el;
  }

  function polarPt(cx, r, angleDeg) {
    var rad = (angleDeg - 90) * Math.PI / 180;
    return { x: cx + r * Math.cos(rad), y: cx + r * Math.sin(rad) };
  }

  function buildWheel(rotor, prizes) {
    var size = 280;
    var cx = size / 2;         // 140 — centre point
    var rimR = cx - 1;         // 139 — outer gold rim
    var inner = cx - 14;       // 126 — wedge disc edge
    var labelR = inner * 0.62; // ~78 — radial position of label text
    var segAngle = 360 / prizes.length;

    var svg = svgEl('svg', {
      viewBox: '0 0 ' + size + ' ' + size,
      role: 'img',
      'aria-label': 'Prize wheel with ' + prizes.length + ' segments'
    });
    svg.style.cssText = 'display:block;width:100%;height:100%;overflow:visible';

    var defs = document.createElementNS(SVG_NS, 'defs');
    defs.innerHTML =
      '<radialGradient id="isf-whe" cx="50%" cy="42%">' +
        '<stop offset="0" stop-color="#EDEEE6"/><stop offset="1" stop-color="#D8D9C8"/>' +
      '</radialGradient>' +
      '<radialGradient id="isf-who" cx="50%" cy="42%">' +
        '<stop offset="0" stop-color="#F7F7F4"/><stop offset="1" stop-color="#E8E8D8"/>' +
      '</radialGradient>' +
      '<linearGradient id="isf-rim" x1="0" y1="0" x2="1" y2="1">' +
        '<stop offset="0" stop-color="#A07C10"/>' +
        '<stop offset=".2" stop-color="#D4AF37"/>' +
        '<stop offset=".46" stop-color="#F5E08A"/>' +
        '<stop offset=".67" stop-color="#D4AF37"/>' +
        '<stop offset="1" stop-color="#A07C10"/>' +
      '</linearGradient>' +
      '<linearGradient id="isf-gls" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0" stop-color="white" stop-opacity=".34"/>' +
        '<stop offset=".7" stop-color="white" stop-opacity="0"/>' +
      '</linearGradient>';
    svg.appendChild(defs);

    svg.appendChild(svgEl('circle', { cx: cx, cy: cx, r: rimR, fill: 'url(#isf-rim)' }));
    svg.appendChild(svgEl('circle', { cx: cx, cy: cx, r: inner, fill: '#F7F7F4' }));

    prizes.forEach(function (prize, i) {
      var startA = i * segAngle;
      var endA   = (i + 1) * segAngle;
      var midA   = startA + segAngle / 2;
      var s = polarPt(cx, inner, startA);
      var e = polarPt(cx, inner, endA);
      var lp = polarPt(cx, labelR, midA);

      var d = 'M ' + cx.toFixed(2) + ' ' + cx.toFixed(2) +
              ' L ' + s.x.toFixed(2) + ' ' + s.y.toFixed(2) +
              ' A ' + inner + ' ' + inner + ' 0 0 1 ' +
              e.x.toFixed(2) + ' ' + e.y.toFixed(2) + ' Z';

      svg.appendChild(svgEl('path', {
        d: d,
        fill: 'url(#isf-wh' + (i % 2 === 0 ? 'e' : 'o') + ')',
        stroke: '#C8C9B8',
        'stroke-width': '1.5'
      }));

      var lines;
      if (prize.label === 'Free Shipping' || prize.short === 'Free Ship.') {
        lines = ['Free', 'Ship.'];
      } else if (prize.label === 'Mystery Prize' || prize.short === 'Mystery') {
        lines = ['Mystery', 'Prize'];
      } else {
        lines = [prize.short || prize.label];
      }

      var g = svgEl('g', {
        transform: 'rotate(' + midA.toFixed(2) + ' ' + lp.x.toFixed(2) + ' ' + lp.y.toFixed(2) + ')'
      });
      lines.forEach(function (line, li) {
        var yOff = lines.length === 1 ? 0 : (li === 0 ? -5 : 6);
        var txt = svgEl('text', {
          x: lp.x.toFixed(2),
          y: (lp.y + yOff).toFixed(2),
          'text-anchor': 'middle',
          'dominant-baseline': 'middle',
          fill: '#1A1A14',
          'font-family': 'Poppins, sans-serif',
          'font-size': '10',
          'font-weight': '600'
        });
        txt.textContent = line;
        g.appendChild(txt);
      });
      svg.appendChild(g);
    });

    svg.appendChild(svgEl('ellipse', {
      cx: cx, cy: (cx * 0.35).toFixed(2),
      rx: (cx * 0.62).toFixed(2), ry: (cx * 0.18).toFixed(2),
      fill: 'url(#isf-gls)',
      transform: 'rotate(-5 ' + cx + ' ' + (cx * 0.35).toFixed(2) + ')'
    }));

    svg.appendChild(svgEl('circle', { cx: cx, cy: cx, r: '37', fill: '#D4AF37', stroke: 'white', 'stroke-width': '3' }));
    svg.appendChild(svgEl('circle', { cx: cx, cy: cx, r: '32', fill: 'url(#isf-rim)' }));
    svg.appendChild(svgEl('circle', { cx: cx, cy: cx, r: '29', fill: '#5e6035' }));

    rotor.innerHTML = '';
    rotor.appendChild(svg);
  }

  var KEY_WON = 'isf_spin_won';
  var KEY_DOCK = 'isf_spin_docked';

  function storageGet(key) {
    try { return window.localStorage.getItem(key); }
    catch (e) { return null; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); }
    catch (e) {}
  }

  function storageClear(key) {
    try { window.localStorage.removeItem(key); }
    catch (e) {}
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
  }

  function launchConfetti() {
    if (REDUCED_MOTION) return;
    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:10000';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;

    var COLORS = ['#D4AF37','#F5E08A','#A07C10','#52532E','#EDEEE6','#ffffff','#c0b060'];
    var pieces = [];
    for (var i = 0; i < 140; i++) {
      pieces.push({
        x: canvas.width * (0.2 + Math.random() * 0.6),
        y: canvas.height * (0.25 + Math.random() * 0.2),
        w: 5 + Math.random() * 7,
        h: 7 + Math.random() * 9,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        vx: (Math.random() - 0.5) * 10,
        vy: -7 - Math.random() * 9,
        gravity: 0.28,
        rot: Math.random() * 360,
        rotV: (Math.random() - 0.5) * 12,
        alpha: 1
      });
    }

    var raf;
    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var alive = false;
      pieces.forEach(function (p) {
        if (p.alpha <= 0) return;
        alive = true;
        p.vy += p.gravity;
        p.x  += p.vx;
        p.y  += p.vy;
        p.rot += p.rotV;
        if (p.y > canvas.height * 0.65) p.alpha -= 0.025;
        ctx.save();
        ctx.globalAlpha = Math.max(0, p.alpha);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot * Math.PI / 180);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (alive) { raf = requestAnimationFrame(draw); }
      else { canvas.remove(); }
    }
    raf = requestAnimationFrame(draw);
    setTimeout(function () { cancelAnimationFrame(raf); canvas.remove(); }, 5000);
  }

  function init(root) {
    var prizes;
    try { prizes = JSON.parse(root.getAttribute('data-isf-spin-prizes') || '[]'); }
    catch (e) { prizes = []; }
    if (!prizes.length) return;

    var company = root.getAttribute('data-isf-spin-klaviyo-company');
    var list    = root.getAttribute('data-isf-spin-klaviyo-list');

    var overlay   = root.querySelector('[data-isf-spin-overlay]');
    var wheel     = root.querySelector('[data-isf-spin-wheel]');
    var rotor     = root.querySelector('[data-isf-spin-rotor]');
    var hub       = root.querySelector('[data-isf-spin-hub]');
    var form      = root.querySelector('[data-isf-spin-form]');
    var ready     = root.querySelector('[data-isf-spin-ready]');
    var spinning  = root.querySelector('[data-isf-spin-spinning]');
    var result    = root.querySelector('[data-isf-spin-result]');
    var emailInput = root.querySelector('[data-isf-spin-email]');
    var emailShow = root.querySelector('[data-isf-spin-email-show]');
    var consent   = root.querySelector('[data-isf-spin-consent]');
    var error     = root.querySelector('[data-isf-spin-error]');
    var prizeEl   = root.querySelector('[data-isf-spin-prize]');
    var fab       = root.querySelector('[data-isf-spin-fab]');
    var rotation  = 0;
    var step      = 'email';
    var hasWon    = !!storageGet(KEY_WON);

    buildWheel(rotor, prizes);

    function stopRotorAnimations() {
      if (rotor.getAnimations) {
        rotor.getAnimations().forEach(function (anim) { anim.cancel(); });
      }
      rotor.classList.remove('is-rocking');
      rotor.style.animation = 'none';
    }

    function setRock(on) {
      stopRotorAnimations();
      if (!on || REDUCED_MOTION) return;
      rotor.classList.add('is-rocking');
    }

    function show(node) {
      [form, ready, spinning, result].forEach(function (n) {
        if (n !== node) n.hidden = true;
      });
      if (node) node.hidden = false;
    }

    function open() {
      if (hasWon) return;
      storageClear(KEY_DOCK);
      root.hidden = false;
      root.classList.remove('is-docked');
      root.classList.add('is-open');
      fab.hidden = true;
      if (step !== 'ready' && step !== 'spinning' && step !== 'result') {
        step = 'email';
        show(form);
        hub.textContent = 'SPIN';
        setRock(false);
      }
    }

    function dock() {
      if (hasWon || step === 'spinning') return;
      storageSet(KEY_DOCK, '1');
      root.hidden = false;
      root.classList.remove('is-open');
      root.classList.add('is-docked');
      fab.hidden = false;
    }

    function hideForever() {
      hasWon = true;
      storageSet(KEY_WON, '1');
      storageClear(KEY_DOCK);
      root.classList.remove('is-open', 'is-docked');
      root.hidden = true;
      fab.hidden = true;
    }

    function dismiss() {
      if (step === 'spinning') return;
      if (step === 'result' || hasWon) hideForever();
      else dock();
    }

    root.querySelector('[data-isf-spin-close]').addEventListener('click', dismiss);
    root.querySelector('[data-isf-spin-done]').addEventListener('click', hideForever);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismiss();
    });
    fab.addEventListener('click', open);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      error.hidden = true;
      if (!isValidEmail(emailInput.value)) {
        error.textContent = 'Enter a valid email to spin.';
        error.hidden = false;
        return;
      }
      if (!consent.checked) {
        error.textContent = 'Tick the box to get your prize by email.';
        error.hidden = false;
        return;
      }
      step = 'ready';
      show(ready);
      setRock(true);
    });

    function startSpin() {
      if (step !== 'ready') return;
      var index = pickWeightedIndex(prizes);
      var seg = 360 / prizes.length;
      var extraTurns = 9 + Math.floor(Math.random() * 4);
      var from = rotation;
      var target = from + extraTurns * 360 + ((360 - (index * seg + seg / 2) - (from % 360) + 360) % 360);
      var prize = prizes[index];
      var duration = REDUCED_MOTION ? 1 : 8800;

      rotation = target;
      step = 'spinning';
      show(spinning);
      hub.textContent = 'WIN';
      stopRotorAnimations();
      rotor.style.transition = 'none';
      rotor.style.transform = 'rotate(' + from + 'deg)';

      function finishSpin() {
        rotor.style.transform = 'rotate(' + target + 'deg)';
        step = 'result';
        prizeEl.textContent = prize.label;
        emailShow.textContent = emailInput.value;
        result.classList.remove('is-revealed');
        show(result);
        requestAnimationFrame(function () {
          result.classList.add('is-revealed');
        });
        launchConfetti();
        storageSet(KEY_WON, '1');
        hasWon = true;
        subscribeKlaviyo(emailInput.value, prize.label);
      }

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (rotor.animate) {
            var anim = rotor.animate(
              [
                { transform: 'rotate(' + from + 'deg)' },
                { transform: 'rotate(' + target + 'deg)' }
              ],
              {
                duration: duration,
                easing: 'cubic-bezier(0.08, 0.82, 0.08, 1)',
                fill: 'forwards'
              }
            );
            anim.onfinish = finishSpin;
          } else {
            rotor.style.transition = 'transform ' + duration + 'ms cubic-bezier(0.08, 0.82, 0.08, 1)';
            rotor.style.transform = 'rotate(' + target + 'deg)';
            window.setTimeout(finishSpin, duration);
          }
        });
      });
    }

    wheel.addEventListener('click', function () {
      if (step === 'ready') startSpin();
    });
    root.querySelector('[data-isf-spin-now]').addEventListener('click', startSpin);

    function subscribeKlaviyo(email, prizeLabel) {
      if (!company || company === 'PLACEHOLDER_KLAVIYO_COMPANY_ID' ||
          !list    || list    === 'PLACEHOLDER_KLAVIYO_LIST_ID') {
        if (window.console) console.warn('[ISF Spin] Klaviyo IDs are placeholders — skipping subscription. Set isf_klaviyo_company_id and isf_klaviyo_list_id in theme settings.');
        return;
      }
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'revision': '2025-04-01'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              list_id: list,
              custom_source: 'Spin to Win popup',
              email: email,
              properties: { spin_result: prizeLabel }
            }
          }
        })
      }).catch(function (err) {
        if (window.console) console.warn('[ISF Spin] Klaviyo subscription failed:', err);
      });
    }

    if (hasWon) {
      root.hidden = true;
      return;
    }
    if (storageGet(KEY_DOCK)) dock();
    else open();
  }

  function boot() {
    document.querySelectorAll('[data-isf-spin]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
